<template>
    <!-- 分享直播页面 -->
    <div>
      <v-downTip :popShow="popShow" ></v-downTip>
      <div class="liveWrap">
          <!-- 评论发表输入框 -->
          <!-- <div class="commentBox" v-if="true" @touchmove="(e) => {e.preventDefault()}"> -->
          <div class="commentBox" v-if="isShowInput" @touchmove="(e) => {e.preventDefault()}">
            <div class="containBox">
              <textarea
                ref="commentInput" 
                focus="auto"
                @blur="hideInput"
                @input="setMessage" 
                placeholder="说点什么" 
                class="commentArea" 
                v-model="commentText"
                type="text"
              />
              <div class="sendBtn"><span @click="sendMessage('text')">发表</span></div>
            </div>
            
          </div>
          <!-- 登录弹框 -->
          <div class="loginModal" v-if="loginModalFlag" @touchmove="(e)=>{e.preventDefault()}">
            <div class="mainBox">
              <div class="closeBtn" @click="closeLoginModal">x</div>
              <div class="header">登录后才可进行互动</div>
              <div class="phoneBox">
                <div class="left">手机号</div>
                <div class="right"><input type="number" @blur="changeBlur" v-model="phone" placeholder="请输入您的手机号"/></div>
              </div>
              <div class="checkCodeBox">
                <div class="left">验证码</div>
                <div class="right">
                  <input class="code" @blur="changeBlur" @input="setValue" type="number" placeholder="请输入验证码" v-model="checkCode"/>
                  <button :disabled="codeButtonFlag" class="codeBtn" @click="getcode">{{btnText}}</button>
                </div>
              </div>
              <div class="submitBtn" @click="submit">登录</div>
            </div>
          </div>
          <div class="pwdbox" v-if="!pwdflag&&!pageinfo.isEnd&&pageinfo.roomId">
            <img src="../images/pwdboxbg.png" alt="">
            <p>
              <input type="text" v-model="pwd" placeholder="请输入密码查看直播">
            </p>
            <div class="pwdbut" @click="pwdsubmit">确&nbsp;&nbsp;&nbsp;&nbsp;定</div>
          </div>
          <div class="planbox" v-if="pageinfo.isEnd">
            <p class="imgbox endbox"></p>
            <p class="imgboxp">当前直播已结束</p>
          </div>
          <div class="planbox" v-else-if="!pageinfo.roomId">
            <p class="imgbox"></p>
            <p class="imgboxp">用户正在准备中，请等待</p>
          </div>
          <!-- <div class="my_video"  v-show="true"> -->
          <div class="my_video"  v-show="pageinfo.roomId&&pwdflag&&!pageinfo.isEnd">
            <!-- <div class="planbox" v-if="!pageinfo.coverImg">
              <p class="imgbox"></p>
              <p class="imgboxbut" @click="toStore()">去慧殡葬APP播放</p>
            </div> -->
            <div id="video" :style="'background: url('+(pageinfo.coverImg)+') no-repeat;background-size: 100% 100%;height:'+height+';overflow: hidden;'"></div>
            <!-- <video id="my-player" :style="'background: url('+(pageinfo.coverImg)+') no-repeat;background-size: 100% 100%;height:'+height"
                  class="video-js vjs-default-skin vjs-big-play-centered"
                    preload="auto"
                    autoplay
                    style="width: 100%;height: 100%;"
                    controls
                    data-setup='{"html5" : { "nativeTextTracks" : false }}'>
                <source src="http://pull.live.funeralchain.com/live/anyrtcmU5kGWvFTEtt_126098.m3u8">
            </video> -->
            <!-- <div  class="prism-player"  id="J_prismPlayer"></div> -->
            <div class="namewrap clearfix" @click="toStore()">
              <img :src="pageinfo.headImage?pageinfo.headImage:require('../images/headerImg.png')" alt="" />
              <span class="name">{{pageinfo.userName}}</span>
              <span class="guanzhu"></span>
            </div>
            <div class="inputbox" ref="tagsBox">
              <div class="input" id="sendMessageBtn">说点什么...</div>
              <img src="../images/zhibozan.png" alt="" class="icon" id="tagsBtn"/>
              <ul class="animateBox">
                <li v-for="(item, index) in animateItemList" :key="index">
                  <img src="../images/zhibozan.png" class="animation"/>
                </li>
              </ul>
              <!-- <img src="../images/zhibozan.png" :class="animationClass"/> -->
              <div class="numberBox" v-if="likeCount">
                {{likeCount}}
              </div>
            </div>
            <ul class="commentList" id="commentList" v-if="commentList.length">
              <li class="comment" v-for="(item, index) in commentList" :key="index">
                <div class="box" v-if="item.objectName === 'RC:TxtMsg'"><span class="name">{{item.content.user.name + '：'}}</span>{{item.content.content}}</div>
                <div class="box" v-else-if="item.objectName === 'RC:Chatroom:Like'"><span class="name">{{item.content.user.name + ' '}}</span>{{'给主播点了 ' + item.content.counts + ' 个赞'}}</div>
                <div class="box" v-else-if="item.objectName === 'RC:Chatroom:Welcome'"><span class="name">{{item.content.user.name + ' '}}</span> 进入了直播间</div>
                <div class="box" v-else-if="item.objectName === 'RC:Chatroom:User:Quit'"><span class="name">{{item.content.user.name + ' '}}</span> 离开了直播间</div>
              </li>
            </ul>
          </div>
          <div class="livelistWrap">
            <h3>更多精彩直播</h3>
            <ul class="livelist">
              <li v-for="(item,index) in pageinfo.hotLive"  @click="linkstore(item)" :key="index">
                <img :src="item.coverImg?item.coverImg:require('../images/livedefault.jpg')" alt="">
                <span class="zan" v-if="item.likeRank">
                  <i></i>
                  点赞TOP{{item.likeRank}}
                </span>
                <span class="liveing" v-if="!item.destinationPath"></span>
                <div class="textbox">
                  <p>{{item.userName}}</p>
                  <p>{{item.title}}</p>
                  <p>
                    <span class="people">{{item.totalVisit}}</span>
                    <span class="suo" v-if="item.password"></span>
                  </p>
                </div>
              </li>
            </ul>
          </div>
          <!--
          <div>
            <button @click="initRTCP">播放</button>
            <button @click="getSubscribe">订阅</button>
          </div>
          <div class="my_video" ref="myVideoView" style="width:400px;height:400px;border:1px solid red;">22</div>
          -->
      </div>
    </div>
</template>
<script>
import '../js/flexible.debug.js'
import { Field, Toast  } from 'mint-ui';
import global from "../js/global.js"
import weixin from "../js/weixinall.js"
import "../js/rongIMLib.js"
export default {
  data () {
    return {
      scrollTop: '', // 
      popShow:false,
      Rtcp:'',
      shareSwiper:'',
      pubId:'',
      height:'',
      pageinfo:'',
      pwd:'',
      pwdflag:false,
      loginModalFlag: false, // 登录弹框 显示控制阀
      phone: '', // 登录用户的手机号
      checkCode: '', // 验证码
      checkCodeId: '', // 验证码id
      btnText: '获取', // 获取验证码按钮文字
      countNumber: 60, //倒计时读秒数
      codeButtonFlag: false, // 获取验证码按钮禁用开关
      token: '', // 用户登录token --- 用来判断用户是否已登录
      rongyunToken: '', // 融云token--- 用来链接聊天室用
      commentText: '', // 评论内容
      isShowInput: false, // 是否显示评论输入框
      animateItemList: [],
      likeCount: 0, // 获赞数 --- 当前直播间获取的总点赞数
      addLikeCount: 0, // 新增点赞数
      connectFlag: false,  // 用户是否已经连接融云
      canSendMessage: false, // 是否加入聊天室成功 加入成功 -->可以发评论， 加入失败---->不能发消息
      liveInfo: '',
      commentList: [],
      userId: '',
      currentOperation: '', // 当前操作--- 发送信息 或 点赞
    }
  },
  created(){

},
  mounted(){
    this.height = parseInt(window.outerHeight*0.70)+'px'
    // this.Rtcp  = new ArRTCP({
    //     userId: 'user_123',
    //     videoProfile: '',
    //     logLevel: 'info'
    //   });
    // this.Rtcp.initAppInfo('anyrtcsAj6WQz4UtZW', '5739c2c1804f22e5505a2e2c581411b3'); //生产
    //this.Rtcp.initAppInfo('anyrtcmU5kGWvFTEtt', '4458cf9a09995f36da247c73e4f2fd66'); // 测试
    weixin.shareInfo(18,this.$route.query.contentId,this.$route.query.accountId)
    weixin.shareTitle(18,this.$route.query.contentId,(data)=>{
      this.shareSwiper = data;
    });
    
    setTimeout(()=>{
      this.init()
    })
    this.popShow = this.iswx()
    this.popShow = false

    // 发表评论
    document.getElementById("sendMessageBtn").addEventListener('click', () => {
      if (this.token) { // 用户已登录
        this.isShowInput = true
        this.scrollTop = 0
        this.$nextTick(() => {
          this.$refs.commentInput.focus()
          if (!this.canSendMessage){
            this.initChatRoom()
          }
        })

      } else { // 未登录 --- 去登陆
        this.loginModalFlag = true
      }
    });
    
    // 点赞功能
    document.getElementById("tagsBtn").addEventListener('click', () => {
      if (this.token) { // 已登录 --- 
        if (this.canSendMessage) { // 已经加入聊天室 --- 可以去点赞了
          let arr = JSON.parse(JSON.stringify(this.animateItemList))
          arr.push(',') // 动态添加渲染--点赞图标 --点一下，添加一个图标 -- 通过数组形式渲染
          this.animateItemList = arr
          this.addLikeCount = this.addLikeCount + 1 // 累计点在数
          if (this.timer) {
            clearTimeout(this.timer)
            this.timer = null
            this.timer = setTimeout(() => {
              this.sendMessage('tags')
              let addLikeCount = this.addLikeCount
              this.addLikeCount = 0
              this.$http.get('/content/app/live/like?likeCount=' + addLikeCount + '&liveId=' + this.$route.query.contentId,{headers:{"Authorization":"bearer "+this.token+""}}).then(res => {
                clearTimeout(this.timer)
                this.timer = null
                if (res.respCode === 1) {
                  this.likeCount = res.respData
                }
              })
            },200)
          } else {
            this.timer = setTimeout(() => {
              this.sendMessage('tags')
              let addLikeCount = this.addLikeCount
              this.addLikeCount = 0
              this.$http.get('/content/app/live/like?likeCount=' + addLikeCount + '&liveId=' + this.$route.query.contentId,{headers:{"Authorization":"bearer "+this.token+""}}).then(res => {
                clearTimeout(this.timer)
                this.timer = null
                if (res.respCode === 1) {
                  this.likeCount = res.respData
                }
              })
              
            },200)
          }
        } else { // 未加入聊天室 --- 先加入聊天室
          this.initChatRoom()
        }
      } else { // 未登录 --- 去登陆
        this.loginModalFlag = true
      }
    });

    // setTimeout(()=>{
    //   var player = new Aliplayer({
    //     id: "J_prismPlayer",
    //     autoplay: true,
    //     isLive:true,
    //     playsinline:true,
    //     width:"100%",
    //     height:"400px",
    //     controlBarVisibility:"always",
    //     useH5Prism:false,
    //     useFlashPrism:false,
    //     source:"http://pull.live.funeralchain.com/live/anyrtcmU5kGWvFTEtt_184170.m3u8",
    //     cover:""
    //   });
    // },5000)
      // console.log(this)
      // this.$video.options.flash.swf = 'https://cdn.bootcss.com/videojs-swf/5.4.1/video-js.swf';
      // var player = this.$video('my-player'); //my-player为页面video元素的id
      // player.play(); //播放
  },
  methods:{
    iswx(){
      var ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true;
      } else {
        return false;
      }
    },
    pwdsubmit(){
      if(this.pageinfo.password == this.pwd){
        this.pwdflag = true
        this.initRTCP()
      } else {
        this.$Message.warning('密码错误,请重新输入!')
        this.pwd = ''
      }
      
    },
    linkstore(shareSwiper){
      this.popShow = global.toStore(shareSwiper)
    },
    init(){
      this.$http.get("/content/unsecured/live/info/get/by/account?accountId="+this.$route.query.accountId).then((response) => {
        this.pageinfo = response.respData;
        this.pwdflag = !this.pageinfo.password;
        if(response.respData.roomId&&this.pwdflag&&!this.pageinfo.isEnd){
          this.initRTCP()
          // this.initChatRoom()
          //     var videoObject = {
          //       container: '#video', //容器的ID或className
          //       variable: 'player',//播放函数名称
          //       autoplay:true,
          //       mobileCkControls:false,
          //       playsinline:'allow',
          //       mobileAutoFull:false,
          //       overspread:true,
          //       live:true,
          //       video: this.pageinfo.hlsPullUrl
          //     };
          //   var player = new ckplayer(videoObject);
          //   var player = new Aliplayer({
          //   "id": "video",
          //   "source": this.pageinfo.hlsPullUrl,
          //   "width": "100%",
          //   "height": this.height,
          //   "autoplay": false,
          //   "isLive": false,
          //   "cover": this.pageinfo.coverImg?this.pageinfo.coverImg:require('../images/livedefault.jpg'),
          //   "rePlay": false,
          //   "playsinline": true,
          //   "preload": false,
          //   "controlBarVisibility": "hover",
          //   "useH5Prism": true
          // }, function (player) {
          //     console.log("The player is created");
          //   }
          // );
        }
      });
    },
    initRTCP(){
        setTimeout(()=>{
          var timer = setInterval(()=>{
            this.$http.get("/content/unsecured/live/heart?liveId="+this.$route.query.contentId).then((response) => {
              if(response.respData.isStop){
                clearInterval(timer)
                setTimeout(()=>{
                  window.location.reload()
                  this.sendMessage('quit')
                  // console.log(this.rongyunToken)
                },25000)
              }
            });
          },5000)
          var player = new TcPlayer('video', {
            "m3u8": this.pageinfo.hlsPullUrl, //请替换成实际可用的播放地址
            "autoplay" : false,      //iOS 下 safari 浏览器，以及大部分移动端浏览器是不开放视频自动播放这个能力的
            "width": "100%",
            "poster" : {"style":"cover", "src":require('../images/livedefault2.jpg')},
            "live":true,
            "pausePosterEnabled":false,
            "height": this.height,
            });
           
          },500)
      // this.Rtcp.listen(this.pageinfo.roomId)
      //发布媒体流成功
      // this.Rtcp.on("stream-published", (pubId) => {
      //   console.log('stream-published', pubId);
      //   // that.addLog('info', '回调：stream-published，发布媒体流成功');
      //   console.log(222)
      //   this.pubId = this.rtcpId = pubId;
      // });
      // this.Rtcp.on("stream-subscribed", (pubId, mediaRender)=>{
        
      //   this.$refs.myVideoView2.appendChild(mediaRender);
      // });
      // this.Rtcp.on("stream-unsubscribed", (pubId)=>{
      //   this.pageinfo.isEnd = true
      // });
      // this.getSubscribe()
      
      // this.Rtcp.setLocalVideoCapturer().then(e => {
      //   e.mediaRender.id = "myVideo";
      //   this.$refs.myVideoView.appendChild(e.mediaRender);
      //   this.Rtcp.publish(0);
      //   // that.addLog('info', '方法：publish');
      // }).catch(err => {
      //   console.log(err);
      // });
    },
    getSubscribe(){
      //this.Rtcp.listen(this.$route.query.contentId)
    },
    toStore(){
      this.popShow = global.toStore(this.shareSwiper)
    },
    closeTip(){
      this.popShow = false;
    },

    // 聊天室 初始化 -- 连接状态监听
    initChatRoom () {
      // 初始化
      RongIMLib.RongIMClient.init("pvxdm17jporcr")
      this.customMessage()
      // 链接状态监听器
      RongIMClient.setConnectionStatusListener({
        onChanged: function (status) {
          // status 标识当前连接状态
          switch (status) {
            case RongIMLib.ConnectionStatus.CONNECTED:
              console.log('链接成功');
              break;
            case RongIMLib.ConnectionStatus.CONNECTING:
              console.log('正在链接');
              break;
            case RongIMLib.ConnectionStatus.DISCONNECTED:
              console.log('断开连接');
              break;
            case RongIMLib.ConnectionStatus.KICKED_OFFLINE_BY_OTHER_CLIENT:
              console.log('其他设备登录, 本端被踢');
              break;
            case RongIMLib.ConnectionStatus.DOMAIN_INCORRECT:
              console.log('域名不正确, 请至开发者后台查看安全域名配置');
              break;
            case RongIMLib.ConnectionStatus.NETWORK_UNAVAILABLE:
              console.log('网络不可用, 此时可调用 reconnect 进行重连');
              break;
            default:
              console.log('链接状态为', status);
              break;
          }
        }
      })

      // 消息接收监听器--- 接受到消息时触发
      RongIMClient.setOnReceiveMessageListener({
        // 接收到的消息
        onReceived: (message) => {
          var messageContent = message.content;
          // 判断消息类型
          switch(message.objectName) {
            case 'RC:TxtMsg': //  ----------------------------------------------文字消息
              // console.log('收到文字消息',message)
              var arr = JSON.parse(JSON.stringify(this.commentList))
              arr.push(message)
              this.commentList = arr
              this.scrolltoBottom()
              console.log(this.commentList)
              break;
            case 'RC:Chatroom:User:Quit': // ------------------------------退出直播间消息
              // console.log('收到退出消息',message)
              var arr = JSON.parse(JSON.stringify(this.commentList))
              // console.log(arr)
              arr.push(message)
              this.commentList = arr
              this.scrolltoBottom()
              break;
            case 'RC:Chatroom:Welcome': // --------------------------------进入直播间消息
              var arr = JSON.parse(JSON.stringify(this.commentList))
              // console.log('收到欢迎消息',message)
              // console.log(arr)
              arr.push(message)
              this.commentList = arr
              this.scrolltoBottom()
              break;
            case 'RC:Chatroom:Like': // --------------------------------------点赞消息
              // console.log('收到点赞消息',message)
              var arr = JSON.parse(JSON.stringify(this.commentList))
              var animateItemList = JSON.parse(JSON.stringify(this.animateItemList))
              for (let i = 0; i < Number(message.content.counts); i++) {
                setTimeout(() => {
                  animateItemList.push(',')
                  this.animateItemList = animateItemList
                },150 * i)
              }
              // console.log(message.content.message.content)
              // console.log(arr)
              arr.push(message)
              this.commentList = arr
              this.scrolltoBottom()
              this.likeCount = this.likeCount + message.content.counts
              break;
            default:
              console.log('收到消息未知消息', message);
              this.$Message.warning('收到消息未知消息')
              break;
          }
        }
      })

      // 连接融云
      RongIMClient.connect(this.rongyunToken, {
        onSuccess: (userId) => { // 连接成功
          this.connectFlag = true
          this.userId = userId
          // 连接聊天室
          console.log('连接成功')
          this.joinChatRoom()
        },
        onTokenIncorrect: function() {
          console.log('token无效');
        },
        onError:function(errorCode){
              var info = '';
              switch (errorCode) {
                case RongIMLib.ErrorCode.TIMEOUT:
                  info = '超时';
                  break;
                case RongIMLib.ConnectionState.UNACCEPTABLE_PAROTOCOL_VERSION:
                  info = '不可接受的协议版本';
                  break;
                case RongIMLib.ConnectionState.IDENTIFIER_REJECTED:
                  info = 'appkey不正确';
                  break;
                case RongIMLib.ConnectionState.SERVER_UNAVAILABLE:
                  info = '服务器不可用';
                  break;
              }
              console.log(errorCode);
            }
      })
    },

    // 加入聊天室
    joinChatRoom () {
      // var chatRoomId = 'chatroom1';
      var count = 0; //聊天室历史熊希条数
      RongIMClient.getInstance().joinChatRoom(this.liveInfo.roomId, count, {
        onSuccess: () => {
          this.canSendMessage = true
          this.sendMessage('welcome')
          console.log('加入聊天室成功');
        },
        onError: function(error) {
          console.log('加入聊天室失败', error);
        }
      });
    },

    // 退出聊天室
    quitChatRoom () {
      RongIMClient.getInstance().quitChatRoom(this.liveInfo.roomId, {
        onSuccess: function() {
          console.log('退出聊天室成功');
        },
        onError: function(error) {
          console.log('退出聊天室失败');
        }
      });
    },

    // 自定义信息
    customMessage () {
      var mesasgeTag = new RongIMLib.MessageTag(true, true);
      var prototypes1 = ['counts', 'rank', 'level', 'user'];  // 消息类中的属性名
      var prototypes2 = ['id', 'extra', 'user'];  // 消息类中的属性名
      RongIMClient.registerMessageType('welcomeMessage', 'RC:Chatroom:Welcome', mesasgeTag, prototypes1); // 注册欢迎自定义消息
      RongIMClient.registerMessageType('quitMessage', 'RC:Chatroom:User:Quit', mesasgeTag, prototypes2); // 注册退出自定义消息
      // RongIMClient.registerMessageType('消息名称', '消息内置名称', mesasgeTag, '消息类中的属性名');
      this.registerTagsMessage()
    },

    // 注册 ---点赞---自定义消息
    registerTagsMessage () {
      var messageName = 'tagMessage';  // 消息名称
      var objectName = 'RC:Chatroom:Like';  // 消息内置名称，请按照此格式命名
      var isCounted = true;  // 消息计数
      var isPersited = true;  // 消息保存
      var mesasgeTag = new RongIMLib.MessageTag(isCounted, isPersited);
      var prototypes = ['counts', 'extra', 'user'];  // 消息类中的属性名
      RongIMClient.registerMessageType(messageName, objectName, mesasgeTag, prototypes);
    },

    // 发送评论 --- 预处理
    sendMessage (type) {
      let phone = this.phone + ''
      let arr = phone.split('')
      arr.splice(3,4,'****')
      phone = arr.join('')
      var user = {
        name: phone,
        portrait: '',
        id: ''
      }
      var conversationType = RongIMLib.ConversationType.CHATROOM; // 聊天室
      var targetId = this.liveInfo.roomId; // 目标 Id
      if (type === 'text') { // 发送文本型信息
        this.sendTextMessage(conversationType, targetId, user)
      } else if (type === 'tags') { // 发送点赞消息
        this.sendTagsMessage(conversationType, targetId, user)
      } else if (type === 'welcome') { // 发送欢迎消息
        this.sendWelcomeMessage(conversationType, targetId, user)
      } else if (type === 'quit') { // 发送 退出直播间消息
        this.sendQuitMessage(conversationType, targetId, user)
      } else {
        this.$Message.warning('信息发送失败')
      }
    },

    // 发送点赞消息 --- 自定义消息
    sendTagsMessage (conversationType, targetId, user) {
      var msg = new RongIMClient.RegisterMessage.tagMessage({ counts: this.addLikeCount, extra: '', user: user});
      RongIMClient.getInstance().sendMessage(conversationType, targetId, msg, {
          onSuccess: (message) => {
            console.log(message);
            let arr = JSON.parse(JSON.stringify(this.commentList))
            arr.push(message)
            this.commentList = arr
            this.scrolltoBottom()
          },
          onError: function (errorCode) {
              console.log('发送自定义消息失败');
          }
      })
    },
    
    // 发送文本消息
    sendTextMessage (conversationType, targetId, user) {
      var msg = new RongIMLib.TextMessage({ content: this.commentText, extra: '', user: user});
      RongIMClient.getInstance().sendMessage(conversationType, targetId, msg, {
        onSuccess: (message) => {
          // console.log(message)
          // message 为发送的消息对象并且包含服务器返回的消息唯一 Id 和发送消息时间戳
          this.hideInput()
          let arr = JSON.parse(JSON.stringify(this.commentList))
          arr.push(message)
          this.commentList = arr
          this.scrolltoBottom()
          this.commentText = ''
        },
        onError: function (errorCode, message) {
          var info = '';
          switch (errorCode) {
              case RongIMLib.ErrorCode.TIMEOUT:
                  info = '超时';
                  break;
              case RongIMLib.ErrorCode.UNKNOWN:
                  info = '未知错误';
                  break;
              case RongIMLib.ErrorCode.REJECTED_BY_BLACKLIST:
                  info = '在黑名单中，无法向对方发送消息';
                  break;
              case RongIMLib.ErrorCode.NOT_IN_DISCUSSION:
                  info = '不在讨论组中';
                  break;
              case RongIMLib.ErrorCode.NOT_IN_GROUP:
                  info = '不在群组中';
                  break;
              case RongIMLib.ErrorCode.NOT_IN_CHATROOM:
                  info = '不在聊天室中';
                  break;
          }
          console.log('发送失败: ' + info + errorCode);
        }
      })
    },

    // 发送 欢迎消息
    sendWelcomeMessage (conversationType, targetId, user) {
      var msg = new RongIMClient.RegisterMessage.welcomeMessage({ counts: this.addLikeCount, rank: '', level: '', user: user});
      RongIMClient.getInstance().sendMessage(conversationType, targetId, msg, {
          onSuccess: (message) => {
            let arr = JSON.parse(JSON.stringify(this.commentList))
            arr.push(message)
            this.commentList = arr
            this.scrolltoBottom()
          },
          onError: function (errorCode) {
              console.log('发送自定义消息失败');
          }
      })
    },

    // 发送退出直播间消息
    sendQuitMessage (conversationType, targetId, user) {
      var msg = new RongIMClient.RegisterMessage.quitMessage({ id: this.userId, extra: '', user: user});
      RongIMClient.getInstance().sendMessage(conversationType, targetId, msg, {
          onSuccess: (message) => { // 发送成功 退出聊天室
            console.log('发送退出消息成功')
            this.quitChatRoom()
          },
          onError: function (errorCode) {
              console.log('发送自定义消息失败');
          }
      })
    },

    // 用盒子滚动轴显示在最底部
    scrolltoBottom () {
      this.$nextTick(() => {
        let ul = document.getElementById('commentList')
        ul.scrollTop = ul.scrollHeight
      })
    },

    // 设置发送的评论内容
    setMessage ( {target: {value} } ) {
      this.commentText = value
    },

    // 点击 关闭登录弹框 ---清空弹框数据
    closeLoginModal () {
      this.loginModalFlag = false
      this.phone = ''
      this.checkCode = ''
      this.checkCodeId = ''
    },

    // 获取验证码
    getcode () {
      this.codeButtonFlag = true
      if (!this.phone || !(/^1[3456789]\d{9}$/.test(this.phone))) { // 校验失败 
        this.$Message.warning('手机号码有误，请重填')
        this.codeButtonFlag = false
      } else {// 校验成功   获取验证码
        this.$http.get('/account/unsecured/register/login/send/sms?mobile=' + this.phone).then( res => {
          if (res.respCode === 1) { // 获取成功
            this.checkCodeId = res.respData
            this.countDown()
            this.$Message.success(res.respMsg)
          } else { // 获取失败
            this.codeButtonFlag = false
            this.$Message.warning('验证码获取失败，请重新获取')
          }
        })
      }
    },

    // 倒计时--- 计时器
    countDown () {
        this.myInterval = setInterval ( () => {
            if (this.countNumber >= 1) {
                this.countNumber--
                this.btnText = this.countNumber + 's'
            } else {
                clearInterval(this.myInterval)
                this.countNumber = 60
                this.btnText = '重新获取'
                this.codeButtonFlag = false // 取消按钮禁用
            }
        },1000)
    },


    // 登录数据 提交
    submit () {
      if (!this.phone) { // 未输入手机号
        this.$Message.warning('手机号不能为空')
      } else if (!this.checkCodeId) { // 为获取验证码
        this.$Message.warning('请先获取验证码')
      } else { // 请求登录
        this.$http.post('/account/unsecured/register/with/auth?mobile=' + this.phone + '&capatchCode=' + this.checkCode + '&capatchCodeId=' + this.checkCodeId).then( res =>{
          if(res.respCode === 1) {
            this.token = res.respData
            this.getRongYunToken(res.respData)
            // this.loginModalFlag = false
          } else {
            this.$Message.warning(res.respMsg)
          }
        })
      }
    },

    // 获取融云token
    getRongYunToken (token) {
      this.$http.get('/content/app/viewer/live/init?liveId=' + this.$route.query.contentId +'&type=H5&recordedOrlive=1',{headers:{"Authorization":"bearer "+token+""}}).then( res => {
        if (res.respCode === 1) { // token获取成功
          this.liveInfo = res.respData.liveInfo
          this.rongyunToken = res.respData.token
          // this.token = token
          this.$Message.success('登录成功')
          this.loginModalFlag = false
          this.initChatRoom()
        } else {
          this.$Message.warning('登录失败')
        }
      })
    },

    // 限制验证码长度
    setValue ( {target: {value}}) {
      if (value.length > 4) {
        let code = value.substring(0, 4)
        this.checkCode = code
      }
    },

    // input ios兼容处理
    changeBlur () {
      setTimeout(() => {
        var scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
        window.scrollTo(0, Math.max(scrollHeight - 1, 0));
      }, 100);
      // window.scrollTo(0,0)
    },

    // 隐藏评论输入框
    hideInput () {
      this.isShowInput = false
      this.changeBlur()
    },


  },

  destroyed () {
    this.sendMessage('quit')
  },
}
</script>
<style lang="less">
#video{
  .touchable{
    height: 100%;
    video{
      height: 100%;
      object-fit: cover;
    }
  }
}
</style>

<style scoped lang="less">
.liveWrap{
  position: relative;

  .commentBox{
    position: fixed;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    z-index: 99;
    background-color: rgba(0,0,0,.5);

    .containBox{
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 400px;
      background-color: #fff;
      padding: 10px 10px 30px;
      box-sizing: border-box;

      .commentArea{
        width: 100%;
        height: 180px;
        text-indent: 1em;
        padding: 10px;
        outline: none;
        resize:none;
        border: 2px solid #ccc;
        -webkit-appearance: none;
      }

      .sendBtn{
        margin-top: 10px;
        overflow: hidden;

        span{
          float: right;
          height: 66px;
          width: 160px;
          color: #fff;
          text-align: center;
          line-height: 66px;
          background-color: #FE9333;
          border-radius: 8px;
        }
      }
    }
  }

  .loginModal{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0, .5);
    z-index: 99;

    .mainBox{
      padding: 0 60px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 670px;
      height: 696px;
      background-color: #fff;
      border-radius: 40px;

      .closeBtn{
        font-size: 40px;
        line-height: 60px;
        text-align: center;
        width: 60px;
        height: 60px;
        position: absolute;
        right: 20px;
        top: 20px;
      }
      .submitBtn{
        height: 76px;
        line-height: 76px;
        border-radius: 7px;
        color: #fff;
        background-color: #D6000F;
        margin-top: 120px;
        text-align: center;
        font-family: PingFangSC-Medium;
        font-size: 28px;

      }

      .header{
        height: 116px;
        line-height: 116px;
        text-align: center;
        position: relative;
        font-family: PingFangSC-Medium;
        font-size: 32px;
        color: #0D0D0D;
        margin-bottom: 100px;
      }
      
      .header::before{
        content: '';
        display: block;
        width: 60px;
        height: 12px;
        background-color: #D6000F;
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
      }

      .phoneBox,.checkCodeBox{
        height: 66px;
        overflow: hidden;
        margin: 60px 0;

        .left{
          float: left;
          height: 100%;
          width: 100px;
          line-height: 66px;
          font-family: PingFangSC-Regular;
          font-size: 28px;
          color: #0D0D0D;
        }

        .right{
          float: left;
          width: 384px;
          height: 100%;

          input{
            height: 100%;
            width: 100%;
            border-radius: 4px;
            border: 1px solid #979797;
            text-indent: 1em;
            outline: none; // 去除选中状态边框
            -webkit-appearance: none; // 去除内边框阴影
            font-size: 24px;
          }
          input.code{
            width: 210px;
          }

          .codeBtn{
            border: none;
            display: inline-block;
            border-radius: 7px;
            background-color: #D6000F;
            height: 60px;
            width: 134px;
            text-align: center;
            line-height: 60px;
            color: #fff;
            margin-left: 20px;
          }
        }
      }
    }

  }
  .planbox{
    width: 100%;
    position: relative;
    margin-bottom: 170px;
    .imgbox{
      width: 288px;
      height: 240px;
      margin:224px auto 0;
      background: url(../images/planboxbg.png) no-repeat;
      background-size: 100% 100%;
    }
    .nofenmiam{
      width: 288px;
      height: 240px;
      margin:224px auto 0;
      background: url(../images/nofenmiam.png) no-repeat;
      background-size: 100% 100%;
    }
    .endbox{
      background: url(../images/endboxbg.png) no-repeat;
      background-size: 100% 100%;
    }
    .imgboxp{
      margin-top:60px;
      font-size: 28px;
      color: #5B5C66;
      text-align: center;
    }
    .imgboxbut{
      width: 400px;
      height: 80px;
      line-height: 80px;
      margin:80px auto 0;
      background-image: linear-gradient(90deg, #EF4B4B 0%, #F7643C 100%);
      box-shadow: 2px 4px 10px 0 rgba(239,75,75,0.27);
      border-radius: 40px;
      font-size: 32px;
      color: #FFFFFF;
      letter-spacing: 0.2px;
      text-align: center;
    }
  }
  .livelistWrap{
    margin-top:62px;
    padding:0 36px;
  }
  h3{
    font-size: 32px;
    color: #333440;
    height: 36px;
    padding-left: 50px;
    background: url(../images/liveicon.png) 0 0 no-repeat;
    background-size: 34px 36px;
    margin-bottom:32px;
  }
  .livelist{
    display: flex;
    flex-wrap:wrap;
    margin-left:-14px;
    li{
      flex-basis: 332px;
      height: 332px;
      margin-left:14px;
      margin-top:14px;
      position: relative;
      border-radius: 12px;
      img{
        width: 100%;
        height:100%;
        position:absolute;
        top:0;
        left:0;
        border-radius: 12px;
      }
      .zan{
        width: 156px;
        height: 40px;
        line-height: 40px;
        left:16px;
        position: absolute;
        font-size: 24px;
        color: #FFFFFF;
        top:0;
        background-image: linear-gradient(90deg, #FF68CA 2%, #FF6464 99%);
        border-radius: 0 0 16px 16px;
        i{
          height: 24px;
          width: 18px;
          float: left;
          margin-right:8px;
          margin-left:12px;
          margin-top:8px;
          background:url(../images/zan.png) no-repeat;
          background-size: 100% 100%;
        }
      }
      .liveing{
        position:absolute;
        right:0;
        top:0;
        width: 112px;
        height: 40px;
        background: url(../images/liveing.png) no-repeat;
        background-size:100% 100%;
      }
      .textbox{
        position:absolute;
        bottom:20px;
        left:24px;
        font-size: 24px;
        color: #FFFFFF;
        p{
          width: 274px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .people{
          width: 20px;
          height: 24px;
          padding-left:30px;
          background: url(../images/looknum.png) 0 center no-repeat;
          background-size:20px 24px;
        }
        .suo{
          float: right;
          width: 20px;
          height: 24px;
          background: url(../images/suo.png) 0 center no-repeat;
          background-size:20px 24px;
        }
      }
    }
  }
  .my_video{
    height: 100%;
    width: 100%;
    position: relative;
  }
  .namewrap{
    position:absolute;
    height: 80px;
    width: 312px;
    top:40px;
    left:20px;
    background: rgba(0,0,0,0.4);
    border-radius: 40px;
    img{
      float: left;
      width: 64px;
      height:64px;
      margin-top:8px;
      margin-left:8px;
      border-radius: 50%;
    }
    .name{
      float: left;
      margin-left:8px;
      font-size: 28px;
      color: #FFFFFF;
      line-height: 80px;
      width: 84px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .guanzhu{
      width: 96px;
      height: 48px;
      margin-right:8px;
      margin-top:16px;
      float:right;
      background: url(../images/guanzhu.png) no-repeat;
      background-size:100% 100%;
    }
  }
  .inputbox{
    position:absolute;
    bottom:114px;
    left:20px;
    width:94%;
    z-index: 9;
    .input{
      opacity: 0.45;
      font-size: 28px;
      line-height: 68px;
      color: #FFFFFF;
      background: rgba(0,0,0,0.4);
      border-radius: 34px;
      width: 320px;
      height: 68px;
      padding-left:28px;
      float: left;
    }
    .icon{
      position: absolute;
      top: 0;
      right: 0;
      width: 68px;
      height: 68px;
      z-index: 2;
    }

    .animateBox{
      position: absolute;
      right: 0;
      top: 0;
      width: 68px;
      height: 68px;
      z-index: 1;

      li{
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        opacity: 1;
        z-index: 9;
        animation: tags 3s ease ;
      }

      img{
        width: 100%;
        height: 100%;
        display: block;
      }
    }

    .numberBox{
      position: absolute;
      text-align: center;
      right: 0px;
      top: -16px;
      height: 58px;
      font-size: 28px;
      line-height: 48px;
      padding: 0 6px;
      width: 112px;
      color: #fff;
      transform: translateY(-100%);
      background: url('../images/numberBox.png') no-repeat;
      background-size: 100% 100%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }

  .commentList{
    position: absolute;
    left: 20px;
    bottom: 200px;
    height: 280px;
    width: 538px;
    overflow-y: scroll;
    border-radius: 12px;
    z-index: 9;
    // box-shadow: -10px 0px 10px 10px rgba(0,0,0,.5) inset;

    .comment{
      opacity: 0.45;
      background-color: #000000;
      border-radius: 12px;
      padding: 14px 22px;
      line-height: 40px;
      color: #fff;
      font-size: 26px;
      margin-bottom: 18px;

      .box{
        width: 100%;
        height: 100%;

        .name{
          color: #FFD574;
        }
      }
    }
  }
}
.pwdbox{
  img{
    display: block;
    width: 294px;
    height: 280px;
    margin:160px auto 0;
  }
  p{
    height: 44px;
    margin:0 auto;
    width: 654px;
    margin-top:106px;
    background: url(../images/pwdicon.png) 0 0 no-repeat;
    background-size: 44px 44px;
    border-bottom:1px solid #E6E6E6;
    padding-left: 72px;
    padding-bottom: 66px;
    input{
      width:100%;
      border: 0;  // 去除未选中状态边框
      outline: none; // 去除选中状态边框
      font-size: 32px;
      background-color: rgba(0, 0, 0, 0);// 透明背景
    }
  }
  .pwdbut{
    background-image: linear-gradient(90deg, #EF4B4B 4%, #F7643C 100%);
    box-shadow: 0 32px 48px -32px #F35744;
    border-radius: 44px;
    display: block;
    font-size: 32px;
    color: #fff;
    text-align: center;
    width: 400px;
    height: 88px;
    line-height: 88px;
    margin: 120px auto 0;
    cursor: pointer;
  }
}

@keyframes tags {
  from {
    top: 0;
    opacity: 1;
    display: block;
  } 
  to {
    top: -400px;
    opacity: 0;
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/share/sharelivebroadcast.vue